import { useEffect, useState } from "react";
import "./Menu.css";
import { useNavigate } from "react-router-dom";
import { verificaAdmin } from "../../utils/verificaAdmin";
import AdminMenuCategorias from "./AminMenu/AdminMenuCategorias/AdminMenuCategorias";

function Menu({ isOpen, onClose }) {
  const navigate = useNavigate();
  const [view, setView] = useState("main");
  const [activeTitle, setActiveTitle] = useState("");
  const [items, setItems] = useState([]);

  const [abrirAdminCategorias, setAbrirAdminCategorias] = useState(false);

  const [categoriasMenu, setCategoriasMenu] = useState([]);
  const [mostrarTodasCategorias, setMostrarTodasCategorias] = useState(false);

  const isAdmin = verificaAdmin();

  //console.log(isAdmin);


  const carregarCategorias = async () => {
    try {
      const response = await fetch(
        "https://app.eliandroalimentos.com.br/api/categoriasmenu/listarcategoriasmenu"
      );

      const data = await response.json();

      setCategoriasMenu(data);
    } catch (error) {
      console.error("Erro ao carregar categorias:", error);
    }
  };

  useEffect(() => {
    carregarCategorias();
  }, []);


  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setView("main");
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const goToLogin = () => {
    onClose();
    navigate("/login");
  };

  const openSubmenu = (title, list) => {
    setActiveTitle(title);
    setItems(list);
    setView("submenu");
  };

  const goBack = () => {
    setView("main");
    setActiveTitle("");
    setItems([]);
  };

  if (!isOpen) return null;



  const categoriasOrdenadas = [...categoriasMenu].sort((a, b) =>
    a.descricao.localeCompare(b.descricao, "pt-BR")
  );

  const categoriasVisiveis = mostrarTodasCategorias
    ? categoriasOrdenadas
    : categoriasOrdenadas.slice(0, 7);



  return (
    <>
      <div className="menu-overlay" onClick={onClose}></div>

      <aside className="menu-drawer">
        {/* HEADER */}
        <div className="menu-header" onClick={goToLogin}>
          <div className="menu-user-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z" />
              <path d="M4 22c0-3.31 3.58-6 8-6s8 2.69 8 6" />
            </svg>
          </div>
          <span>Bem-vindo, entre aqui</span>
        </div>

        {/* ================= MENU PRINCIPAL ================= */}
        {view === "main" && (
          <>
            {/* CATEGORIAS */}
            <div className="menu-section">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h4>Todas as Categorias</h4>

                {isAdmin && (
                  <button
                    className="btn-editar-categorias"
                    onClick={() => setAbrirAdminCategorias(true)}
                  >
                    Editar
                  </button>
                )}
              </div>
              <ul>
                {categoriasVisiveis.map((categoria) => (
                  <li
                    key={categoria.id}
                    className="menu-item simple"
                    onClick={() => {
                      onClose();
                      navigate(`/categorias/${categoria.codgrupo}`);
                    }}
                  >
                    <span>{categoria.descricao}</span>
                  </li>
                ))}
              </ul>

              {categoriasMenu.length > 7 && (
                <button
                  className="ver-mais"
                  onClick={() => setMostrarTodasCategorias(!mostrarTodasCategorias)}
                >
                  {mostrarTodasCategorias ? "Ver menos ▴" : "Ver mais ▾"}
                </button>
              )}

            </div>

            {/* SOBRE A ELIANDRO */}
            <div className="menu-section">
              <h4>Sobre a Eliandro</h4>
              <ul>
                <li
                  className="menu-item"
                  onClick={() =>
                    openSubmenu("Carreiras", [
                      {
                        titulo: "Trabalhe conosco",
                        rota: "/portalcandidato",
                        novaAba: true,
                      },
                      {
                        titulo: "Seja nosso representante comercial",
                        rota: "/seja-um-representante",
                      },
                    ])
                  }
                >
                  <span>Carreiras</span>
                  <span className="arrow">›</span>
                </li>

                <li
                  className="menu-item"
                  onClick={() =>
                    openSubmenu("Conteúdo Eliandro", [
                      {
                        titulo: "Quem somos",
                        rota: "/quem-somos",
                      },
                      {
                        titulo: "Como comprar",
                        rota: "/como-comprar",
                      },
                    ])
                  }
                >
                  <span>Conteúdo Eliandro</span>
                  <span className="arrow">›</span>
                </li>
              </ul>
            </div>
          </>
        )}

        {/* ================= SUBMENU ================= */}
        {view === "submenu" && (
          <div className="menu-section submenu">
            <div className="submenu-header" onClick={goBack}>
              ← Voltar
            </div>

            <div className="submenu-title">
              <strong>{activeTitle}</strong>
            </div>

            <ul>
              {items.map((item) => (
                <li
                  key={item.titulo}
                  className="menu-item simple"
                  onClick={() => {
                    onClose();

                    if (item.novaAba) {
                      window.open(item.rota, "_blank");
                    } else {
                      navigate(item.rota);
                    }
                  }}
                >
                  {item.titulo}
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>

      {abrirAdminCategorias && (
        <div
          className="admin-modal-overlay"
          onClick={() => setAbrirAdminCategorias(false)}
        >
          <div
            className="admin-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <AdminMenuCategorias
              onClose={() => setAbrirAdminCategorias(false)}
              onAtualizarCategorias={carregarCategorias}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Menu;
